export default "__VITE_ASSET__0FqMs8q2__"